import { render, staticRenderFns } from "./VMobileNav.vue?vue&type=template&id=68046336&"
import script from "./VMobileNav.vue?vue&type=script&lang=js&"
export * from "./VMobileNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports